import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "store/reducers";
import { AccountDeleteModal } from "components/modal/AccountDeleteModal";
import { useSwitcherClient } from "hooks/useSwitcherClient";
import rollbar from "helpers/rollbar";
import { usePauseStatus } from "hooks/usePauseStatus";
import Loading from "components/loading/Loading";
import { useTranslation } from "react-i18next";

/** this is only ever accessed in app */
export const AccountDeletionPage: React.FC = () => {
    const { t } = useTranslation();
    const user = useSelector((state: RootState) => state.user);
    const { userIsPaused } = usePauseStatus();
    const [hasActiveSubscription, setHasActiveSubscription] =
        React.useState<boolean>(false);

    const { loading } = useSwitcherClient(
        (client) => client.stripe_GetCustomer,
        {
            requestImmediately: true,
            onError: (e) => {
                rollbar.error(
                    "Error getting user stripe customer subscription info for account deletion in app",
                    e
                );
            },
            onSuccess: (data) => {
                const subscription = data?.StripeSubscriptions?.[0];
                if (subscription) {
                    if (
                        (subscription.Status === "active" ||
                            subscription.Status === "trialing" ||
                            userIsPaused) &&
                        !subscription.CancelAtPeriodEnd
                    ) {
                        setHasActiveSubscription(true);
                    } else {
                        setHasActiveSubscription(false);
                    }
                }
            }
        }
    );

    if (!user.userInfo?.User?.Details?.Id) {
        return null;
    } else {
        return loading ? (
            <Loading />
        ) : hasActiveSubscription ? (
            <p>{t("errors:user-has-active-subscription")}</p>
        ) : (
            <AccountDeleteModal isOpen={true} setIsOpen={() => {}} />
        );
    }
};
